// src/components/CookAI/LegalPages/PrivacyPolicy.tsx
import React from "react";
import { ColorTheme } from "../../../themes/colors";
import { getLegalStyles } from "../../../themes/styles/legal";
import { useLanguage } from "../../../i18n/LanguageContext";
import { legalTranslations } from "../../../i18n/legalTranslations";
import LanguageDropdown from "../Navigaton/LanguageDropdown";

interface PrivacyPolicyProps {
    theme: ColorTheme;
    onBack: () => void;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ theme, onBack }) => {
    const styles = getLegalStyles(theme);
    const { language } = useLanguage();
    const l = legalTranslations[language];
    const p = l.privacy;

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div style={styles.header}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
                        <button
                            style={styles.backButton}
                            onClick={onBack}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-2px)";
                                e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.2)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)";
                            }}
                        >
                            {l.backButton}
                        </button>
                        <LanguageDropdown theme={theme} />
                    </div>
                    <h1 style={styles.title}>
                        <span style={styles.gradientText}>{p.pageTitle}</span>
                    </h1>
                    <p style={styles.lastUpdated}>{l.lastUpdated}</p>
                </div>

                <div style={styles.section}>
                    <p style={styles.paragraph}>
                        {p.intro.replace('Cook AI', '')}
                        <span style={styles.highlight}>Cook AI</span>
                        {p.intro.split('Cook AI')[1]}
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{p.s1Title}</h2>
                    <p style={styles.paragraph}>{p.s1Intro}</p>
                    <ul style={styles.list}>
                        {p.s1Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{p.s2Title}</h2>
                    <p style={styles.paragraph}>{p.s2Intro}</p>
                    <ul style={styles.list}>
                        {p.s2Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{p.s3Title}</h2>
                    <p style={styles.paragraph}>{p.s3Text}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{p.s4Title}</h2>
                    <p style={styles.paragraph}>{p.s4Text}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{p.s5Title}</h2>
                    <p style={styles.paragraph}>{p.s5Text}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{p.s6Title}</h2>
                    <p style={styles.paragraph}>{p.s6Intro}</p>
                    <ul style={styles.list}>
                        {p.s6Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{p.s7Title}</h2>
                    <p style={styles.paragraph}>{p.s7Text}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{p.s8Title}</h2>
                    <p style={styles.paragraph}>{p.s8Text}</p>
                </div>

                <div style={styles.contactBox}>
                    <h2 style={styles.contactTitle}>{p.contactTitle}</h2>
                    <p style={styles.contactText}>{p.contactText}</p>
                    <a
                        href="mailto:thecookaiapp@gmail.com"
                        style={styles.link}
                    >
                        thecookaiapp@gmail.com
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
